import type { AuthContextType } from "./AuthContext";
import { createContext } from "react";

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
